import React from 'react';

import Translation from '@swf/components/Translation/Translation';
import type { Currency } from '@swf/core/enums';

import { TXTCLI_Buy_In } from './BuyIns.messages.json';
import styles from './BuyIns.scss';

interface Props {
  currency?: Currency;
  buyIns?: string;
}

const BuyIns = ({ currency, buyIns }: Props) => {
  if (!buyIns || !currency) return null;
  const { minBuyIn, maxBuyIn } = JSON.parse(buyIns);

  return (
    <p className={styles.caption}>
      <Translation tagName="span" {...TXTCLI_Buy_In} />
      {`${minBuyIn} - ${maxBuyIn} BB`}
    </p>
  );
};

export default BuyIns;
